<template>
  <div class="wrapper" v-if="!$cookies.get('account-type') && is_login">
    <div class="__container">
      <div class="form">
        <div class="logo-container">
          <img src="@/assets/image/new_logo.svg" />
        </div>
        <div class="banner">
          <h1>Welcome</h1>
          <span>A few steps to get started…</span>
        </div>
        <div class="login_form">
          <div class="chech-box">
            <input
              type="radio"
              id="consultant"
              name="account_type"
              value="1"
              v-model="account_type"
            />
            <label for="consultant">I am a consultant</label>
          </div>
          <div class="chech-box">
            <input
              type="radio"
              id="customer"
              name="account_type"
              value="2"
              v-model="account_type"
            />
            <label for="customer"
              >I am a customer and I want to hire consultants</label
            >
          </div>
          <div class="chech-box">
            <input
              type="radio"
              id="supplier"
              name="account_type"
              value="3"
              v-model="account_type"
            />
            <label for="supplier"
              >I am a supplier and I want to manage consultants</label
            >
          </div>
          <button class="get-started" @click="registerUser()">
            Get Started
          </button>
          <div class="loader" v-show="loading">
            <img src="@/assets/icons/loading_blue.gif" alt />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- On outh -->
  <div class="wrapper" v-else>
    <div class="logo">
      <router-link to="/">
        <img src="@/assets/image/new_logo.svg" />
      </router-link>
    </div>
    <h1 v-show="!verified && loading">Please wait...</h1>
    <h1 v-show="verify_error">Error while verifying your account,Try again.</h1>
    <button
      v-show="verify_error"
      class="login-btn"
      @click="$router.push({ name: 'login' })"
    >
      Go back
    </button>
    <div class="loader" v-show="loading">
      <img src="@/assets/icons/loading_blue.gif" alt />
    </div>
    <h1 v-show="verified">Redirecting...</h1>
  </div>
</template>
<script>
import { eventBus } from "@/main";
import * as axios from "axios";
import { AUTH_SET_TYPE } from "@/Store/Actions/auth";
import { AUTH_SET_TYPE_URL, API } from "@/Store/variable";

export default {
  name: "TokenRedirect",
  data() {
    return {
      loading: false,
      verified: false,
      verify_error: false,
      account_type: 1,
      is_login: false,
    };
  },
  computed: {
    isInvited() {
      return !(
        this.$cookies.get("project-token") === null &&
        this.$cookies.get("employment-token") === null
      );
    },
  },
  mounted() {
    let vm = this;
    if (vm.$cookies.get("account-type") && !is_login) {
      vm.loading = true;
      axios({
        url: API + AUTH_SET_TYPE_URL,
        method: "POST",
        data: {
          id: vm.$route.params.id,
          type: vm.$cookies.get("account-type"),
        },
      })
        .then((response) => {
          vm.$cookies.remove("account-type");
          vm.loading = false;
          vm.verified = true;
          sessionStorage.authToken = response.data.access_token;
          sessionStorage.siteAuthToken = response.data.access_token;
          sessionStorage.setItem("isLogedIn", true);
          sessionStorage.setItem("account_type", response.data.account_type);
          eventBus.$socket.emit("register", response.data.id);
          if (this.isInvited) {
            vm.$router.push({ name: "invitation_wizard" });
          } else {
            if (response.data.activated === false) {
              vm.$router.push({ name: "get-started" });
            } else {
              vm.$router.push({ name: "feeds" });
            }
          }
        })
        .catch((error) => {
          vm.loading = false;
          vm.verify_error = true;
          console.log(error);
        });
    } else {
      if (vm.route.query.exists) {
        if (vm.route.query.exists == "true") {
          vm.loading = true;
          axios({
            url: API + AUTH_SET_TYPE_URL,
            method: "POST",
            data: {
              id: vm.$route.params.id,
            },
          })
            .then((response) => {
              vm.$cookies.remove("account-type");
              vm.loading = false;
              vm.verified = true;
              sessionStorage.authToken = response.data.access_token;
              sessionStorage.siteAuthToken = response.data.access_token;
              sessionStorage.setItem("isLogedIn", true);
              sessionStorage.setItem(
                "account_type",
                response.data.account_type
              );
              eventBus.$socket.emit("register", response.data.id);
              if (this.isInvited) {
                vm.$router.push({ name: "invitation_wizard" });
              } else {
                if (response.data.activated === false) {
                  vm.$router.push({ name: "get-started" });
                } else {
                  vm.$router.push({ name: "feeds" });
                }
              }
            })
            .catch((error) => {
              vm.loading = false;
              vm.verify_error = true;
              console.log(error);
            });
        }
      } else {
        vm.is_login = sessionStorage.getItem("is_login");
      }
    }
  },
  methods: {
    registerUser() {
      let vm = this;
      vm.loading = true;
      axios({
        url: API + AUTH_SET_TYPE_URL,
        method: "POST",
        data: {
          id: vm.$route.params.id,
          type: vm.account_type,
        },
      })
        .then((response) => {
          vm.loading = false;
          sessionStorage.authToken = response.data.access_token;
          sessionStorage.siteAuthToken =
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvZGV2ZWxvcG1lbnQuY29uc3VsdGlmaWVkLmNvbVwvYXBpXC9hdXRoXC9sb2dpbiIsImlhdCI6MTYwNDY2NzY2OCwiZXhwIjoxNjA0NzAzNjY4LCJuYmYiOjE2MDQ2Njc2NjgsImp0aSI6InJ5ZmxRSEE0Rm1IdmxjbVciLCJzdWIiOjkyLCJwcnYiOiI4N2UwYWYxZWY5ZmQxNTgxMmZkZWM5NzE1M2ExNGUwYjA0NzU0NmFhIn0.5lqJFdRcvom9YmNV4j3gpFf6LPj0HPXoO9rYRWDnwgE";
          sessionStorage.setItem("isLogedIn", true);
          sessionStorage.setItem("account_type", response.data.account_type);
          eventBus.$socket.emit("register", response.data.id);
          if (this.isInvited) {
            vm.$router.push({ name: "invitation_wizard" });
          } else {
            if (response.data.activated === false) {
              vm.$router.push({ name: "get-started" });
            } else {
              vm.$router.push({ name: "feeds" });
            }
          }
        })
        .catch((error) => {
          vm.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";
.wrapper {
  width: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  overflow: hidden;
  background-size: contain;
  background-repeat: no-repeat !important;
  background-position: center;
  .__container {
    .form {
      display: flex;
      flex-direction: column;
      .logo-container {
        display: flex !important;
        justify-content: center;
        img {
          width: 80px;
        }
      }
      .login_form {
        margin-top: 0px;
        text-align: left;
        @media (min-width: 300px) and (max-width: 630px) {
          padding-left: 20px;
          padding-right: 20px;
        }
        .chech-box {
          margin: 15px 0 10px 0;
          display: flex;
          align-items: center;
          input {
            margin-top: 3px;
            margin-right: 10px;
          }
          label {
            font-family: "Nunito", sans-serif;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.36;
            letter-spacing: 0px;
            text-align: center;
            color: #000000;
          }
          .colored {
            cursor: pointer;
            text-decoration: underline;
            margin-left: 10px;
            color: #1890a9;
          }
        }
        .get-started {
          width: 291px;
          height: 45px;
          background: transparent
            linear-gradient(109deg, #1ba5a4 0%, #2f90b6 100%) 0% 0% no-repeat
            padding-box;
          border-radius: 5px;
          color: #fff;
          margin-top: 30px;
        }
        .loader {
          display: flex;
          justify-content: center;
          margin-top: 10px;
          img {
            width: 30px;
          }
        }
        .label {
          color: #000;
          font-weight: normal;
          font-size: 14px;
          margin-top: 15px;
          margin-bottom: 4px;
          margin-left: 20px;
        }
        .error_input {
          border: 1px solid crimson !important;
          color: crimson;
        }
        .error-msg {
          color: crimson;
          text-align: left;
        }
        .input:focus {
          outline: none !important;
          box-shadow: none;
        }

        input[type="text"],
        input[type="email"],
        input[type="password"] {
          width: 400px;
          padding: 10px;
          height: 45px;
          background-color: #ffffff;
          border: 1px solid #ccc;
          @media (min-width: 300px) and (max-width: 630px) {
            width: 300px;
          }
          border-radius: 5px;
          background-size: 20px 15px;
          background-origin: content-box;
          background-repeat: no-repeat;
          &:focus {
            outline: none;
          }
        }
      }
      .logo,
      .login_form {
        display: flex;
        flex-direction: column;
      }

      .banner span {
        font-size: 16px;
        color: #000000;
        font-weight: normal;
      }
      .banner h1 {
        text-align: center;
        font-size: 20px;
        color: #1ba5a4;
        margin-top: 25px;
        margin-bottom: 25px;
      }
      .title h1 {
        text-align: center;
        font-size: 20px;
        color: #1ba5a4;
        margin-top: 25px;
        margin-bottom: 10px;
      }
      .bottom {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-top: 15px;
        .signup {
          color: #1885ad !important;
          margin-top: 10px;
          cursor: pointer;
          margin-bottom: 10px;
        }
        input[type="button"] {
          background: #1885ad;
          width: 400px;
          height: 45px;
          outline: none;
          border-radius: 5px;
          padding: 7px;
          color: #fff;
          text-align: center;
          @media (min-width: 300px) and (max-width: 630px) {
            width: 300px;
          }
        }
        input[type="checkbox"] {
          background-color: #ffffff;
          position: relative;
          top: -1px;
          margin-right: 5px;
        }
        .sign-in-up-option {
          color: #1ba5a4;

          margin-top: 20px;
          margin-bottom: 5px;
        }
        .loader {
          margin-top: 10px;
          img {
            width: 30px;
          }
        }
        .social-media-list {
          list-style: none;
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          margin-top: 20px;
          @media (min-width: 300px) and (max-width: 630px) {
            display: grid;
            grid-template-columns: 48% 48%;
            grid-gap: 10px;
          }
          li.linkedin {
            margin-right: 10px;
            a {
              display: flex;
              align-items: center;
              background: #fff;
              padding: 3px 7px;
              border-radius: 5px;
              span {
                margin-top: 2px;
                margin-left: 3px;
                color: #3773bb;
              }
            }
          }
          li.google {
            margin-right: 10px;
            a {
              display: flex;
              align-items: center;
              background: #fff;
              padding: 3px 7px;
              border-radius: 5px;
              span {
                margin-top: 2px;
                margin-left: 3px;
              }
            }
          }
          li.facebook {
            margin-right: 10px;
            a {
              display: flex;
              align-items: center;
              background: #4765a3;
              padding: 3px 7px;
              border-radius: 5px;
              span {
                margin-top: 2px;
                margin-left: 3px;
                color: #fff;
              }
            }
          }
          li.microsoft {
            margin-right: 10px;
            a {
              display: flex;
              align-items: center;
              background: #fff;
              padding: 3px 7px;
              border-radius: 5px;
              span {
                margin-top: 2px;
                margin-left: 3px;
                color: #000;
              }
            }
          }
        }
        .dont-have-account {
          color: #8f95a4;
          a {
            color: #0884af;
            text-decoration: none;
          }
        }
      }
    }
  }
  .logo {
    margin-bottom: 80px;
    img {
      width: 150px;
    }
  }
  .login-btn {
    background: #1885ad;
    width: 100px;
    height: 45px;
    outline: none;
    border-radius: 5px;
    padding: 7px;
    color: #fff;
    text-align: center;
  }
}
</style>